window.addEventListener("load", () => {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        let video = entry.target;
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.5 }
  );

  document.querySelectorAll(".video-local").forEach((video) => {
    observer.observe(video);
  });
  document
    .querySelectorAll(".video-banner-section-muted")
    .forEach((video_el) => {
      let video_muted = video_el.querySelector(".video-local");
      video_el.querySelector(".play-button-c").click();
      if (video_muted) {
        var source = video_muted.querySelector("source");
        if (source) {
          source.src = source.getAttribute("data-src");
          video_muted.load();
          video_muted.play();
        }
      }
    });
});

document.querySelectorAll(".video-banner-section-muted").forEach((video_el) => {
  video_el
    .querySelector(".video-local.video-local-desktop")
    .addEventListener("click", () => startPlaying(video_el, true));
  video_el
    .querySelector(".video-button-muted")
    .addEventListener("click", () => startPlaying(video_el));
});

const startPlaying = (video_el, isDesktop) => {
  let video = video_el.querySelector(".video-local");

  if (isDesktop) {
    video = video_el.querySelector('.video-local.video-local-desktop');
  }
  const videoButtonMutted = video_el.querySelector(".video-button-muted");
  const isEnable = !videoButtonMutted.classList.contains('c-hide');

  if (video.muted === false) {
    if (isEnable) video.muted = true;
    video.play();

    if (videoButtonMutted && isEnable) {
      videoButtonMutted.style.opacity = "1";
    }
  } else {
    if (isEnable) video.muted = false;
    video.play();

    if (videoButtonMutted && isEnable) {
      videoButtonMutted.style.opacity = "0";
    }
  }
};

//   .delivery-widget__container {
//     border-radius: 8px;
//     border: 2px solid rgba(89, 240, 153, 0.20);
//     background: rgba(89, 240, 153, 0.30);
//     padding: 12px 16px
//     }


const videoWrapperGV = document.querySelectorAll('.video-wrapper-c-g-v');
const videoWrapperMob = document.querySelectorAll('.mobile-video-c');
const iconPlayPause = document.querySelectorAll('.icon-pause-play-c-mob');

function newVideoToggleHandler(item) {
  item.addEventListener('click', () => {
    item.classList.toggle('no-muted');
    startPlaying(item);
  })
}

videoWrapperGV.forEach(item => {
  newVideoToggleHandler(item);
});

videoWrapperMob.forEach(item => {
  newVideoToggleHandler(item);
});


document.querySelectorAll('.has-muted-button-c').forEach(block => {
  block.addEventListener('click', () => {
    const video = block.querySelector('video');

    if (video) {
      video.muted = !video.muted;
      block.classList.toggle('is-no-muted');
    }

  })
})

const customMutedBlocks = document.querySelectorAll('.has-custom-muted-c');

customMutedBlocks.forEach(block => {
  block.addEventListener('click', () => {
    const video = block.querySelector('video');

    if (block.classList.contains('show-muted-button-c')) {
      block.classList.add('is-no-muted-bloc');
      block.classList.remove('show-muted-button-c');

      if (video) {
        video.muted = false;
      }

    } else {
      block.classList.remove('is-no-muted-bloc');
      block.classList.add('show-muted-button-c');

      if (video) {
        video.muted = true;
      }
    }
  })
})

iconPlayPause.forEach(item => {
  const wrapper = item.closest('.mobile-video-c');
  if (wrapper) {
    wrapper.addEventListener('click', () => {
      const video = wrapper.querySelector('video');
      if (video) {
        video.muted = !video.muted;
      }
    })
  }
});